import { PromotionStatBlocks } from "@/app/Promotions/Components/PromotionStatBlocks";
import { PromotionTable } from "@/app/Promotions/Components/PromotionTable";
import { promotionCountsQuery } from "@/app/Promotions/GraphQL/promotionCountsQuery";
import { adTableRoute } from "@/app/Promotions/Routes/adRoutes";
import { adTabActive, adTabs } from "@/app/Promotions/Utils/adTabs";
import { Badge } from "@/components/catalyst/badge";
import {
  Navbar,
  NavbarItemLink,
  NavbarSection,
} from "@/components/catalyst/navbar";
import { Skeleton } from "@/components/ui/skeleton";
import { FullPageScreen } from "@/lib/Components/Screens/FullPageScreen";
import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { Suspense } from "react";
import { useTranslations } from "use-intl";

export function AdTableScreen() {
  const { adTab } = adTableRoute.useSearch();
  const t = useTranslations("promotion.ads");

  return (
    <FullPageScreen className="space-y-6">
      <h3 className="text-base font-semibold leading-6 text-gray-900">
        {t("title")}
      </h3>

      <Suspense fallback={<Skeleton className="h-44 w-full" />}>
        <PromotionStatBlocks />
      </Suspense>

      <div>
        <Suspense fallback={<Skeleton className="h-10 w-full" />}>
          <Tabs />
        </Suspense>

        <PromotionTable id="ads" active={adTabActive(adTab)} />
      </div>
    </FullPageScreen>
  );
}

function Tabs() {
  "use no memo";

  const t = useTranslations("promotion.ads");
  const { adTab } = adTableRoute.useSearch();
  const { data } = useSuspenseGqlQuery(promotionCountsQuery, {});

  return (
    <div className="border-b border-gray-200">
      <Navbar className="-mb-px">
        <NavbarSection>
          {adTabs.map(({ id, badgeColor }) => (
            <NavbarItemLink
              key={id}
              to="/$tenant/$orgId/supplier/{-$supplierId}/ads"
              params={(prev) => prev}
              current={adTab === id}
              search={{ adTab: id }}
            >
              {t(id)}

              <div>
                <Badge className="py-0" color={badgeColor}>
                  {id === "all"
                    ? data.promotionCounts.total
                    : data.promotionCounts[id]}
                </Badge>
              </div>
            </NavbarItemLink>
          ))}
        </NavbarSection>
      </Navbar>
    </div>
  );
}
